import { MenuItem } from './typings.d'
import { UserAuthority, DrugStoreType, CnMedDrugStoreType } from '-/typings/index.d'
import { EUserRoles } from '-/typings/user.d'

const menuData: MenuItem[] = [
  {
    name: '商品管理',
    icon: 'appstore',
    path: 'drug-management',
    authority: 'drugManage',
    allowRoles: [EUserRoles.DRUGSTORE_ADMIN, EUserRoles.CHANNEL_ADMIN],
    children: [
      {
        name: '西药管理',
        hideChildrenInMenu: true,
        path: 'drug',
        authority: 'drug',
        children: [
          {
            name: '西药 SKU 列表',
            path: 'sku/list',
            hideInMenu: true,
          },
          {
            name: '西药 SKU 详情',
            path: 'sku/detail',
            hideInMenu: true,
          },
          {
            name: '西药申请详情',
            path: 'apply/detail',
            hideInMenu: true,
          },
          {
            name: '西药编辑',
            path: 'sku/edit',
            hideInMenu: true,
          },
          {
            name: '新增西药',
            path: 'spu/list',
            hideInMenu: true,
          },
          {
            name: '西药 SPU 详情',
            path: 'spu/detail',
            hideInMenu: true,
          },
          {
            name: '西药申请首营',
            path: 'spu/apply',
            hideInMenu: true,
          },
          {
            name: '西药申请增加规格',
            path: 'spu/packAdd',
            hideInMenu: true,
          },
          {
            name: '西药申请上架',
            path: 'spu/sale',
            hideInMenu: true,
          },
        ],
      },
      {
        name: '医疗器械管理',
        hideChildrenInMenu: true,
        path: 'machine',
        authority: 'machine',
        children: [
          {
            name: '医疗器械 SKU 列表',
            path: 'sku/list',
            hideInMenu: true,
          },
          {
            name: '医疗器械 SKU 详情',
            path: 'sku/detail',
            hideInMenu: true,
          },
          {
            name: '医疗器械 SPU 列表',
            path: 'spu/list',
            hideInMenu: true,
          },
          {
            name: '医疗器械 SPU 详情',
            path: 'spu/detail',
            hideInMenu: true,
          },
        ],
      },
      {
        name: '营养保健管理',
        hideChildrenInMenu: true,
        path: 'health',
        authority: 'health',
        children: [
          {
            name: '营养保健 SKU 列表',
            path: 'sku/list',
            hideInMenu: true,
          },
          {
            name: '营养保健 SKU 详情',
            path: 'sku/detail',
            hideInMenu: true,
          },
          {
            name: '营养保健 SPU 列表',
            path: 'spu/list',
            hideInMenu: true,
          },
          {
            name: '营养保健 SPU 详情',
            path: 'spu/detail',
            hideInMenu: true,
          },
          {
            name: '营养保健申请新增',
            path: 'spu/apply',
            hideInMenu: true,
          },
          {
            name: '营养品申请详情',
            path: 'apply/detail',
            hideInMenu: true,
          },
          {
            name: '营养保健申请增加规格',
            path: 'spu/packApply',
            hideInMenu: true,
          },
          {
            name: '营养保健申请上架',
            path: 'spu/sale',
            hideInMenu: true,
          },
        ],
      },
      {
        name: '化妆品管理',
        hideChildrenInMenu: true,
        path: 'cosmetic',
        authority: 'cosmetic',
        children: [
          {
            name: '化妆品 SKU 列表',
            path: 'sku/list',
            hideInMenu: true,
          },
          {
            name: '化妆品 SKU 详情',
            path: 'sku/detail',
            hideInMenu: true,
          },
          {
            name: '化妆品 SPU 列表',
            path: 'spu/list',
            hideInMenu: true,
          },
          {
            name: '化妆品 SPU 详情',
            path: 'spu/detail',
            hideInMenu: true,
          },
        ],
      },
      {
        name: '中药管理',
        hideChildrenInMenu: true,
        path: 'chinese',
        authority: 'chinese',
        children: [
          {
            name: '中药 SKU 列表',
            path: 'sku/list',
            hideInMenu: true,
          },
          {
            name: '中药 SKU 详情',
            path: 'sku/detail',
            hideInMenu: true,
          },
          {
            name: '中药 SPU 列表',
            path: 'spu/list',
            hideInMenu: true,
          },
          {
            name: '中药 SPU 详情',
            path: 'spu/detail',
            hideInMenu: true,
          },
          {
            name: '中药申请新增',
            path: 'spu/apply',
            hideInMenu: true,
          },
          {
            name: '中药申请详情',
            path: 'apply/detail',
            hideInMenu: true,
          },
          {
            name: '中药申请增加规格',
            path: 'spu/packApply',
            hideInMenu: true,
          },
          {
            name: '中药申请上架',
            path: 'spu/sale',
            hideInMenu: true,
          },
        ],
      },
      {
        name: '生活用品管理',
        hideChildrenInMenu: true,
        path: 'life',
        authority: 'life',
        children: [
          {
            name: '生活用品 SKU 列表',
            path: 'sku/list',
            hideInMenu: true,
          },
          {
            name: '生活用品 SKU 详情',
            path: 'sku/detail',
            hideInMenu: true,
          },
          {
            name: '生活用品 SPU 列表',
            path: 'spu/list',
            hideInMenu: true,
          },
          {
            name: '生活用品 SPU 详情',
            path: 'spu/detail',
            hideInMenu: true,
          },
        ],
      },
    ],
  },
  {
    name: '处方管理',
    icon: 'block',
    path: 'prescription-management',
    authority: 'prescriptionManage',
    allowRoles: [
      EUserRoles.ADMIN,
      EUserRoles.PHARMACIST,
      EUserRoles.CHANNEL_ADMIN,
      EUserRoles.DRUGSTORE_ADMIN,
    ],
    children: [
      {
        name: '普通处方管理',
        hideChildrenInMenu: true,
        path: 'online',
        authority: 'online',
        children: [
          {
            name: '普通处方列表',
            path: 'list',
            hideInMenu: true,
          },
          {
            name: '普通处方详情',
            path: 'detail',
            hideInMenu: true,
          },
        ],
      },
      {
        name: '补方管理',
        hideChildrenInMenu: true,
        path: 'sup-pres',
        authority: 'sup-pres',
        allowRoles: [EUserRoles.ADMIN, EUserRoles.DRUGSTORE_ADMIN],
        children: [
          {
            name: '补方列表',
            path: 'list',
            hideInMenu: true,
          },
          {
            name: '补方详情',
            path: 'detail',
            hideInMenu: true,
          },
          {
            name: '新增补方',
            path: 'add',
            hideInMenu: true,
          },
        ],
      },
    ],
  },
  {
    name: '结算管理',
    icon: 'trademark',
    path: 'settlement',
    authority: 'finalCharge',
    allowRoles: [EUserRoles.ADMIN, EUserRoles.DRUGSTORE_ADMIN, EUserRoles.CHANNEL_ADMIN],
    children: [
      {
        name: '结算单列表',
        hideChildrenInMenu: true,
        path: 'list',
      },
    ],
  },
  {
    name: '订单管理',
    icon: 'number',
    path: 'order-management',
    authority: 'channelManage',
    allowRoles: [EUserRoles.ADMIN, EUserRoles.CHANNEL_ADMIN, EUserRoles.DRUGSTORE_ADMIN],
    children: [
      {
        name: '订单管理',
        hideChildrenInMenu: true,
        path: 'order',
        authority: 'order',
        children: [
          {
            name: '订单列表',
            path: 'list',
            hideInMenu: true,
          },
          {
            name: '订单详情',
            path: 'detail',
            hideInMenu: true,
          },
          {
            name: '创建退款单',
            path: 'create-refund',
            authority: 'refund',
          },
          {
            name: '创建售后单',
            path: 'create-after-sales',
            authority: 'afterSales',
          },
        ],
      },
      {
        name: '监管码录入',
        hideChildrenInMenu: true,
        allowRoles: [EUserRoles.DRUGSTORE_ADMIN],
        path: 'supervise',
        authority: 'supervise',
      },
      {
        name: '监管码查询',
        hideChildrenInMenu: true,
        allowRoles: [EUserRoles.DRUGSTORE_ADMIN],
        path: 'superviseDetail',
        authority: 'superviseDetail',
        children: [
          {
            name: '监管码列表',
            path: 'list',
            hideInMenu: true
          },
          {
            name: '监管码详情',
            path: 'detail',
            hideInMenu: true,
          },
        ]
      },
      {
        name: '发货单管理',
        hideChildrenInMenu: true,
        path: 'invoice',
        authority: 'invoice',
        allowRoles: [EUserRoles.SUPER_ADMIN, EUserRoles.DRUGSTORE_ADMIN],
        children: [
          {
            name: '发货单列表',
            path: 'list',
            hideInMenu: true,
          },
        ],
      },
      {
        name: '订单推送管理',
        hideChildrenInMenu: true,
        path: 'orderPush',
        authority: 'orderPush',
        allowRoles: [
          EUserRoles.SUPER_ADMIN,
          EUserRoles.ADMIN,
          EUserRoles.CHANNEL_ADMIN,
          EUserRoles.DRUGSTORE_ADMIN,
        ],
        children: [
          {
            name: '订单推送列表',
            path: 'list',
            hideInMenu: true,
          },
          {
            name: '订单详情',
            path: 'detail',
            hideInMenu: true,
          },
        ],
      },
    ],
  },
  {
    name: '对码管理',
    icon: 'block',
    path: 'code-management',
    authority: 'codeManage',
    // TODO
    allowRoles: [EUserRoles.ADMIN, EUserRoles.CHANNEL_ADMIN, EUserRoles.DRUGSTORE_ADMIN],
    children: [
      {
        name: '店铺对码',
        path: 'storeCode',
        authority: 'storeCodeManage',
      },
      {
        name: '商品对码',
        path: 'goodsCode',
        authority: 'goodsCodeManage',
      },

    ]
  },
  {
    name: '售后管理',
    icon: 'insurance',
    path: 'after-sale-management',
    authority: 'afterSaleManage',
    allowRoles: [EUserRoles.ADMIN, EUserRoles.DRUGSTORE_ADMIN],
    children: [
      {
        name: '退款单管理',
        hideChildrenInMenu: true,
        path: 'refund-slip',
        authority: 'refund-slip',
        children: [
          {
            name: '退款单列表',
            path: 'list',
            hideInMenu: true,
          },
          {
            name: '退款单详情',
            path: 'detail',
            hideInMenu: true,
          },
        ],
      },
      {
        name: '售后单管理',
        hideChildrenInMenu: true,
        path: 'after-order',
        authority: 'after-order',
        children: [
          {
            name: '售后单列表',
            path: 'list',
            hideInMenu: true,
          },
          {
            name: '售后单详情',
            path: 'detail',
            hideInMenu: true,
          },
        ],
      },
    ],
  },
  {
    name: '成员管理',
    icon: 'team',
    authority: 'userManage',
    path: 'user-management',
    hideChildrenInMenu: true,
    allowRoles: [EUserRoles.ACCOUNT_ADMIN],
    children: [
      {
        name: '成员列表',
        path: 'list',
        hideInMenu: true,
      },
      {
        name: '添加成员',
        path: 'add',
        hideInMenu: true,
      },
      {
        name: '编辑成员',
        path: 'edit',
        hideInMenu: true,
      },
    ],
  },
  {
    name: '运费管理',
    icon: 'pay-circle',
    authority: 'freightManage',
    path: 'freight-management',
    hideChildrenInMenu: true,
    allowRoles: [EUserRoles.DRUGSTORE_ADMIN, EUserRoles.CHANNEL_ADMIN],
    children: [
      {
        name: '运费模板列表',
        path: 'list',
        hideInMenu: true,
      },
      {
        name: '新增运费模板',
        path: 'add',
        hideInMenu: true,
      },
      {
        name: '编辑运费模板',
        path: 'edit',
        hideInMenu: true,
      },
      {
        name: '选择药品',
        path: 'select-drugs',
        hideInMenu: true,
      },
      {
        name: '关联药品',
        path: 'relation',
        hideInMenu: true,
      },
    ],
  },
  {
    name: '库存管理',
    icon: 'folder',
    authority: 'stock-warning',
    path: 'stock-warning',
    hideChildrenInMenu: true,
    allowRoles: [EUserRoles.DRUGSTORE_ADMIN],
  },
  {
    name: '通知',
    icon: 'notification',
    path: 'notification',
    hideLeftMenu: true,
    hideChildrenInMenu: true,
    allowRoles: [EUserRoles.DRUGSTORE_ADMIN],
  },
  {
    name: '大客户管理',
    icon: 'usergroup-add',
    authority: 'key-account',
    path: 'key-account',
    hideChildrenInMenu: true,
    allowRoles: [EUserRoles.DRUGSTORE_ADMIN],
    children: [
      {
        name: '大客户优惠',
        path: 'discount',
        hideInMenu: true,
      },
      {
        name: '客户列表',
        path: 'account',
        hideInMenu: true,
      },
    ],
  },
  {
    name: '中药设置',
    icon: 'setting',
    authority: 'setting',
    path: 'setting',
    hideChildrenInMenu: true,
    allowRoles: [EUserRoles.DRUGSTORE_ADMIN],
    storeType: [
      [DrugStoreType.Chinese, CnMedDrugStoreType.All],
      [CnMedDrugStoreType.YinPian, CnMedDrugStoreType.All, CnMedDrugStoreType.Keli],
    ],
  },
  {
    name: '模式设置',
    icon: 'control',
    authority: 'model-setting',
    path: 'model-setting',
    hideChildrenInMenu: true,
    allowRoles: [EUserRoles.DRUGSTORE_ADMIN],
    storeType: [
      [DrugStoreType.Chinese, DrugStoreType.All],
      [CnMedDrugStoreType.YinPian, CnMedDrugStoreType.Keli, CnMedDrugStoreType.All],
    ],
  },
  {
    name: '配置',
    icon: 'experiment',
    authority: 'config-setting',
    path: 'config-setting',
    hideChildrenInMenu: true,
    allowRoles: [EUserRoles.DRUGSTORE_ADMIN],
    storeType: [
      [DrugStoreType.Western, DrugStoreType.All],
      [CnMedDrugStoreType.YinPian, CnMedDrugStoreType.Keli, CnMedDrugStoreType.All, 0],
    ],
  },
  {
    name: '账户',
    icon: 'user',
    path: 'user',
    hideInMenu: true,
    children: [
      {
        name: '登录',
        path: 'login',
      },
    ],
  },
  {
    name: '个人中心',
    icon: 'idcard',
    path: 'personal',
    hideInMenu: true,
  },
  {
    name: '合作订单管理',
    icon: 'apartment',
    authority: 'partnerOrder',
    path: 'partner-order',
    allowRoles: [EUserRoles.ADMIN, EUserRoles.DRUGSTORE_ADMIN],
    children: [
      {
        name: 'B2B出库单',
        authority: 'outbound',
        allowRoles: [EUserRoles.ADMIN],
        path: 'outbound',
      },
      {
        name: '采购入库单',
        authority: 'warehousing',
        allowRoles: [EUserRoles.DRUGSTORE_ADMIN],
        hideChildrenInMenu: true,
        path: 'warehousing',
        children: [
          {
            name: '采购入库单列表',
            path: 'list',
            hideInMenu: true,
          },
          {
            name: '采购入库单详情',
            path: 'detail',
            hideInMenu: true,
          },
        ]
      },
    ]
  },
  {
    name: '开店',
    icon: 'line-chart',
    path: 'open-store',
    authority: 'openStore',
    allowRoles: [EUserRoles.DRUGSTORE_ADMIN],
    children: [
      {
        name: '进程查询',
        hideChildrenInMenu: true,
        path: 'process-query',
        authority: 'process',
      },
      {
        name: '基础资料',
        hideChildrenInMenu: true,
        path: 'basic-info',
        authority: 'basic',
      },
      {
        name: '商户信息',
        hideChildrenInMenu: true,
        path: 'business-info',
        authority: 'business',
      },
      {
        name: '协议签署',
        hideChildrenInMenu: true,
        path: 'agreement-sign',
        authority: 'agreement',
      }
    ]
  }
]

/**
 * 格式化菜单
 *
 * [{                             [{
 *   name: 'AAA',                   authority: undefined,
 *   icon: 'AAA',                   children: [{
 *   path: 'aaa',                     authority: undefined,
 *   children: [                      name: 'BBB',
 *     {                              path: '/aaa/bbb',
 *       name: 'BBB',               }],
 *       path: 'bbb',    =>         icon: 'AAA',
 *     },                           name: 'AAA',
 *   ],                             path: '/aaa',
 * }, {                           }, {
 *   name: 'XXX',                   authority: 'admin',
 *   icon: 'XXX',                   children: [{
 *   path: 'xxx',                     authority: 'admin',
 *   authority: 'admin',              name: 'YYY',
 *   children: [{                     path: '/xxx/yyy'
 *     name: 'YYY',                 }],
 *     path: 'yyy'                  icon: 'XXX',
 *   }],                            name: 'XXX',
 * }]                               path: '/xxx'
 *                                }]
 * @export
 * @param {*} data 菜单原始数组
 * @param {string} parentPath 分隔符
 * @param {*} parentAuthority 父级菜单的权限
 * @returns {array}
 */
function formatter(
  data: MenuItem[],
  parentPath = '/',
  parentAuthority?: UserAuthority,
  type?: number[]
): MenuItem[] {
  return data
    .filter(item => {
      const storeType = type || []
      const [currentStoreType, currentCnMedStoreType] = storeType
      if (!item.storeType) return true
      if (!type) return true
      if (
        item.storeType[0].includes(currentStoreType) &&
        item.storeType[1].includes(currentCnMedStoreType)
      ) {
        return true
      }
      return false
    })
    .map(item => {
      let { path } = item

      if (!path.startsWith('/')) {
        path = `${parentPath}${path}`
      }

      let authority = item.authority || ''
      if (parentAuthority && item.authority) {
        authority = `${parentAuthority}-${item.authority}`
      } else if (parentAuthority) {
        authority = parentAuthority
      }

      const result = {
        ...item,
        path,
        authority,
      }

      if (item.children) {
        result.children = formatter(item.children, `${result.path}/`, result.authority)
      }

      return result
    })
}

export const getMenuData = (type?: number[]): MenuItem[] =>
  formatter(menuData, '/', undefined, type)

export default undefined
